// Employee sections that other modules' pages embed (#253): the signed-in
// employee's own info tabs on /account/info. Registered from `./index` at
// bootstrap; the page renders it by id and does not import Employee.
// Contract: `src/lib/slots.tsx`. Registrations only.
import { registerSlot } from '@/lib/slots'

registerSlot({
    id: 'employee.self-personal-info',
    load: () => import('./components/Update/SelfPersonalInfo'),
})
